import { TextField } from "@mui/material";

const SearchBox = (props) => {
  const {
    placeholder,
    disabled,
    onSearch,
    onKeyPress,
    isFull = true,
    size,
  } = props;

  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      className={`${isFull ? "w-100" : ""} `}
    >
      <TextField
        fullWidth
        id="search-in-ippis"
        defaultValue=""
        size="small"
        className="mr-2"
        onChange={(e) => onSearch(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onKeyPress()}
        placeholder={placeholder}
        label={placeholder}
        disabled={disabled}
        autoComplete="off" // This disables autofill
        type="text"
        name="search-in-ippis"
      />
    </form>
  );
};

export default SearchBox;
